import FreeBusyCacheManager from './FreeBusyCacheManager';
import { PAGE_SIZE_IN_DAYS, CACHE_SIZE_IN_PAGES } from '../constants';

const freeBusyCache: FreeBusyCacheManager = new FreeBusyCacheManager(
    PAGE_SIZE_IN_DAYS,
    CACHE_SIZE_IN_PAGES
);

export default freeBusyCache;
